import { useContext } from "react";
import cont from '../../context/UIContext';

const useUI = () => {
  return useContext(cont);
};

export default useUI;
